import React, { Fragment } from "react";

import { Skeleton } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core";

import { SkillsAccordionSkeletonProps } from "./types";

const useStyles = (dark: boolean) =>
  makeStyles(theme => ({
    skeleton: {
      backgroundColor: dark ? "#B0BEC5" : "rgba(0, 0, 0, 0.04)",
      margin: theme.spacing(1),
    },
    overallPercentageProgressBar: {
      width: "100%",
    },
  }));

const SkillsAccordionSkeleton: React.FC<SkillsAccordionSkeletonProps> = ({
  dark = false,
}) => {
  const classes = useStyles(dark)();
  return (
    <Fragment>
      <Skeleton
        variant="rect"
        width="85%"
        height={430}
        className={classes.skeleton}
      />
    </Fragment>
  );
};

export default SkillsAccordionSkeleton;
